import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomHelpText from '@s-ui/react-atom-help-text'
import AtomTextarea, {AtomTextareaResizes} from '@s-ui/react-atom-textarea'
import Context from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import SpinnerBasic, {spinnerBasicOverlayTypes, spinnerBasicSizes, spinnerBasicTypes} from '@adv-mt/mt-spinner-basic'

import {BASE_CLASS, INPUT_MAX_LENGTH, SEARCH_AI_INPUT_ID} from '../config.js'

const SearchAiField = ({value, onChange, isLoading, onSubmit}) => {
  const {domain, i18n} = useContext(Context)
  const appName = domain.get('config').get('APP_NAME')
  const inputSearchLabel = i18n.t(`SEARCH_AI.FILTERS.INPUT_SEARCH.${appName}`)

  const handleChangeInputSearch = e => {
    const search = e.target.value
    onChange(search)
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (value.trim()) {
        onSubmit?.()
      }
    }
  }

  return (
    <div className={`${BASE_CLASS}-inputContainer`}>
      <div>
        {isLoading && (
          <SpinnerBasic
            overlayType={spinnerBasicOverlayTypes.TRANSPARENT}
            type={spinnerBasicTypes.SECTION}
            size={spinnerBasicSizes.SMALL}
          />
        )}
        <VisuallyHidden as="label" htmlFor={SEARCH_AI_INPUT_ID}>
          {inputSearchLabel}
        </VisuallyHidden>
        <AtomTextarea
          id={SEARCH_AI_INPUT_ID}
          value={value}
          onChange={handleChangeInputSearch}
          onKeyDown={handleKeyDown}
          placeholder={inputSearchLabel}
          disabled={isLoading}
          maxLength={INPUT_MAX_LENGTH}
          resize={AtomTextareaResizes.NONE}
          rows="1"
        />
      </div>
      <AtomHelpText id={`${SEARCH_AI_INPUT_ID}-help`} text={i18n.t('SEARCH_AI.FILTERS.DISCLAIMER')} />
    </div>
  )
}

SearchAiField.displayName = 'SearchAiField'
SearchAiField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool
}

export default SearchAiField
